export function buildDocsDocumentationHref(docsBaseUrl: string, slug?: string): string {
  const base = docsBaseUrl.replace(/\/$/, '')

  return slug ? `${base}/${slug}` : `${base}/`
}
